import { render, staticRenderFns } from "./resetpsw.vue?vue&type=template&id=0e65ed64&scoped=true"
import script from "./resetpsw.vue?vue&type=script&lang=js"
export * from "./resetpsw.vue?vue&type=script&lang=js"
import style0 from "./resetpsw.vue?vue&type=style&index=0&id=0e65ed64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65ed64",
  null
  
)

export default component.exports